import { lsColorGray, lsColorPrimary, lsColorWhite } from "./constants";

export const antdTheme = {
    token: {
        colorPrimary: lsColorPrimary,
        colorLink: lsColorPrimary,
        colorBgLayout: lsColorWhite,
        colorTextBase: lsColorGray,
        colorText: lsColorGray,

        borderRadius: 10,

        controlHeight: 42,

        fontFamily: "Mulish",
        fontSize: 18,
    },
    components: {
        Steps: {
            iconSizeSM: 28,
        },
        Segmented: {
            trackBg: "#f5f5f5",
            trackPadding: 5,
            itemSelectedColor: "#0F962E",
        },
    },
};
